import React, { ReactElement } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import FsFilterArrowIcon from 'ui-elements/icons/FsFilterArrow';
import { getIconStyle } from './FsOutlinedSelect.style';
import {
  CustomFormControl,
  CustomTextField,
} from './FsOutlinedSelect.style-elements';

interface ItemProps {
  value: string;
  label: string;
}

interface FsOutlinedSelectProps {
  value: string;
  label?: string;
  name?: string;
  options?: ItemProps[];
  onChange?: (event: React.ChangeEvent<{ value: string }>) => void;
}

const FsOutlinedSelect: React.FC<FsOutlinedSelectProps> = ({
  options = [],
  name,
  value,
  label,
  onChange,
}) => {
  const iconStyle = getIconStyle();
  const handleChange = (event: React.ChangeEvent<{ value: string }>): void => {
    if (onChange) onChange(event);
  };

  return (
    <CustomFormControl variant="outlined">
      <CustomTextField
        select
        name={name}
        // defaultValue="all"
        fullWidth
        size="small"
        onChange={handleChange}
        value={value}
        variant="outlined"
        label={label}
        SelectProps={{
          IconComponent: ({ className, props }): ReactElement => (
            <i
              {...props}
              className={`material-icons ${className}`}
              style={iconStyle}
            >
              <FsFilterArrowIcon />
            </i>
          ),
        }}
      >
        {options.map(({ value: itemValue, label: itemLabel }) => (
          <MenuItem key={itemValue} value={itemValue}>
            {itemLabel}
          </MenuItem>
        ))}
      </CustomTextField>
    </CustomFormControl>
  );
};

export default FsOutlinedSelect;
